import { CustomAudiencesReportLabel } from 'modules/audiences/components/AudiencesReportCustomLabels/CustomAudiencesReportLabel';
import { AUDIENCE_STATUS } from 'modules/audiences/config/audiencesConsts';
import { MODULE_NAME as AUDIENCES_MODULE } from 'modules/audiences/config/routes';
import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import { isUserPermissionOrFeatureFlagEnabled } from 'modules/taboola-common-frontend-modules/account-configurations/utils/isUserPermissionOrFeatureFlagEnabled';
import * as FIELDS from '../../fields';
import { FILTER_TYPE } from '../../filters';
import { REPORT_PRESET } from '../../pickers';
import columnDefinitions from './columnDefinitions';
import { FIRST_PARTY_REPORT_ID } from './firstPartyReportId';
import { customColumns, defaultColumns } from './reportPresets';

export const firstPartyReportConfig = {
    id: FIRST_PARTY_REPORT_ID,
    label: 'Custom Audiences',
    visibilityCondition: ({ permissions, configs: { selectedAccountConfig } }) =>
        isUserPermissionOrFeatureFlagEnabled(
            permissions,
            selectedAccountConfig,
            'CREATE_CUSTOMER_FILE_ALLOWED',
            FEATURE_FLAGS.CREATE_CUSTOMER_FILE_ALLOWED
        ),
    module: AUDIENCES_MODULE,
    endpoint: 'first-party-audience-report',
    labelComponent: CustomAudiencesReportLabel,
    rowIdField: FIELDS.ID.field,
    columnsDef: columnDefinitions,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
    },
    customPreset: { columns: customColumns, initialState: defaultColumns },
    footerColumnDef: [],
    isEmptyFooter: true,
    searchPlaceholderMsgId: 'app.reports.firstParty.search.placeholder',

    // TODO: DEV-58584 need to convert filter names in the GW. replace sortField + remove sortMap
    // searchField: NAME.field
    searchField: FIELDS.AUDIENCE_NAME.field,
    sortMap: {
        [FIELDS.NAME.field]: FIELDS.AUDIENCE_NAME.field,
    },
    initialFilters: [
        {
            id: FILTER_TYPE.AUDIENCE_STATUS,
            type: FILTER_TYPE.AUDIENCE_STATUS,
            values: [
                {
                    value: AUDIENCE_STATUS.ALL_BUT_ARCHIVED,
                    label: 'All but archived',
                    messageId: 'report.audienceStatus.ALL_BUT_ARCHIVED',
                },
            ],
            accountConfigurations: { [FEATURE_FLAGS.REPORT_AUTO_FILTERS]: 'true' },
        },
    ],
    filters: [{ id: FILTER_TYPE.AUDIENCE_STATUS }],
};

export default firstPartyReportConfig;
